import { computed, toJS } from 'mobx';
import LocationModel from '../../models/Location/LocationModel';
import BaseStore from '../BaseStore';

export default class LocationStore extends BaseStore {
  constructor(transportLayer) {
    super(LocationModel, transportLayer);
  }

  getLocationHierarchy() {
    let items = Object.assign([], this.items.map(item => ({
      id: item.id,
      name: item.name,
      full_location: this.getFullLocation(item),
    })));
    return items.filter(item => item.full_location === item.name || !items.find(i => !!i.full_location && item.full_location !== i.full_location && i.full_location.indexOf(item.full_location) > -1))
  }

  getFullLocation(item, i = 0) {
    let parent = this.findById(item.parent_id);
    if (!parent) {
      return item.name
    } else {
      return `${item.name}, ${i > 10 ? '...' : this.getFullLocation(parent, i + 1)}`
    }
  }

  isPartOf(subLocationId, locationId) {
    if (!subLocationId || !locationId) return false;
    if (subLocationId === locationId) return true;
    let subLocation = this.findById(subLocationId);
    return this.isPartOf(subLocation.parent_id, locationId)
  }

};


// WEBPACK FOOTER //
// ./src/stores/Location/LocationStore.js